import React, { useEffect, useState } from "react";
import "./HospitalityV2Track.scss"
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { setOrderTrackingData } from "../../../../../../../../redux/resturantWidgetSlice";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../RestaurantWidget/utilities/helper/helper";
import { getOrderDetails } from "../../../../RestaurantWidget/utilities/api/restaurantsService";
import MenuNavbarMini from "../../../components/Navbar/MenuNavbarMini";
import MenuFooterMini from "../../../components/Footer/MenuFooter/MenuFooterMini";
import tick from "../../../assets/tick-black.svg"
import message from "../../../assets/message.svg"
import phone from "../../../assets/phone-line.svg"
import SupportModal from "./SupportModal/SupportModal";
import MenuFooter from "../../../components/Footer/MenuFooter/MenuFooter";


const HospitalityV2OrderStatus = () => {
    const { orderTrackingData } = useSelector((state) => state.resturantData);
    const companyDetails = useSelector((state) => state.companyData.companyDetails);

    const storeOrderLocalData = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_DATA)) : null
    const customerDetails = orderTrackingData?.Customers[0]
    const [showPhone, setShowPhone] = useState(false)
    const dispatch = useDispatch()
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const steps = [{
        head: "Order Recieved",
        sub: "Your order has been successfully placed and confirmed by the restaurant. They’ll start preparing it shortly.",
        status: 'CREATED'
    }, {
        head: "Preparing",
        sub: "The restaurant has started preparing your food with care. It’ll be ready for pickup soon.Restaurant is preparing your food",
        status: 'PREPARING'

    }, {
        head: "Out for Delivery",
        sub: "Your order is on the move and will reach you shortly. Our delivery partner is approaching your location. You can continue tracking them in real-time on the map.",
        status: 'SCHEDULED'

    }, {
        head: "Order Completed",
        sub: `Your order has been delivered. We hope you enjoy your meal! Thank you for ordering from ${orderTrackingData?.Store?.Name}`,
        status: 'FINISHED'

    }
    ]
    const getSteps = () => {
        if (orderTrackingData.FulfillmentType !== "DELIVERY_BY_REWARDCONSUMER") {
            steps.splice(2, 1)
            return steps
        } else {
            return steps
        }
    }
    const getPrice = (
        basePrice
    ) => {
        let priceValue;
        switch (orderTrackingData.FulfillmentType) {
            case "DELIVERY_BY_REWARDCONSUMER":
                priceValue = basePrice.Delivery.FormattedText;
                break;
            case "DINE_IN":
                priceValue = basePrice.DineIn.FormattedText;
                break;
            case "TAKE_AWAY":
                priceValue = basePrice.TakeAway.FormattedText;
                break;
            default:
                priceValue = basePrice.Delivery.FormattedText;
                break;
        }
        return priceValue
    }

    const getEstimation = () => {
        let esitimation;
        switch (orderTrackingData.StateVal) {
            case "CREATED":
                esitimation = "Order confirmation time : " + moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A');
                break;
            case "PREPARING":
                esitimation = "Preparation completion time : " + moment(new Date(orderTrackingData.PreparationTime.ReadyForPickupTime)).format('HH:mm A');
                break;
            case "SCHEDULED":
                esitimation = "Expected delivery time : " + moment(new Date(orderTrackingData.ScheduledOrderTargetDeliveryTimeRange.EndTime)).format('HH:mm A');
                break;
            case "FINISHED":
                esitimation = "Order completion time : " + moment(new Date(orderTrackingData.CompletedTime)).format('HH:mm A');
                break;
            default:
                esitimation = "Order confirmation time : " + moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A');
                break;
        }
        return esitimation
    }

    const getTimeEstimation = (status) => {
        let esitimation;
        switch (status) {
            case "CREATED":
                esitimation = moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A');
                break;
            case "PREPARING":
                esitimation = moment(new Date(orderTrackingData.PreparationTime.ReadyForPickupTime)).format('HH:mm A');
                break;
            case "SCHEDULED":
                esitimation = moment(new Date(orderTrackingData.ScheduledOrderTargetDeliveryTimeRange.EndTime)).format('HH:mm A');
                break;
            case "FINISHED":
                esitimation = moment(new Date(orderTrackingData.CompletedTime)).format('HH:mm A');
                break;
            default:
                esitimation = moment(new Date(orderTrackingData.CreatedTime)).format('HH:mm A');
                break;
        }
        return esitimation
    }
    const updateState = (order) => {
        if (order.State === "CREATED" && order.PreparationStatus === "") {
            order.StateVal = "CREATED"
        }
        if (order.State === "CREATED" && order.PreparationStatus === "PREPARING") {
            order.StateVal = "PREPARING"
        }
        if (order.State === "CREATED" && order.PreparationStatus !== "" && order.Deliveries.Status === "SCHEDULED"
        ) {
            order.StateVal = "SCHEDULED"
        }
        if (order.State === "FINISHED") {
            order.StateVal = "FINISHED"
        }
        return order
    }
    useEffect(() => {
        if (orderTrackingData) {
            getOrderDetails(orderTrackingData.OrderID, storeOrderLocalData.cloudLocationID).then((response) => {
                if (response) {
                    dispatch(setOrderTrackingData(updateState(response)))

                }
            })
        }
    }, [])

    const renderModifierGroups = (selectedGroup, item) => {
        return (
            <div>
                {selectedGroup.SelectedItems.map((selectedItem, index) => (
                    <span key={index}>
                        <span className="addon-title">
                            {selectedItem.Title.replace(/\.+$/, '')} <span className="qty-box">{Math.floor(selectedItem.Quantity.Amount / item.Quantity.Amount)}</span>
                        </span>
                        {selectedItem.SelectedModifierGroups && selectedItem.SelectedModifierGroups.length > 0 && (
                            <span>
                                {selectedItem.SelectedModifierGroups.map((nestedGroup, nestedIndex) => (
                                    <span key={nestedIndex}> {renderModifierGroups(nestedGroup, item)}</span>
                                ))}
                            </span>
                        )}
                        {index < selectedGroup.SelectedItems.length - 1 && <span>, </span>}
                    </span>
                ))}
            </div>
        );
    };
    const exportToPDF = () => {
        const input = document.getElementById("orderCart");

        html2canvas(input, {
            scale: 2, // Optional for better quality
            useCORS: true, // Ensure proper CORS handling for images
        }).then((canvas) => {
            const pdf = new jsPDF();

            pdf.addImage(canvas.toDataURL("image/png"), "PNG", 10, 10, 100, 0);

            // Save the PDF
            pdf.save("order_summary.pdf");
        });
    };
    const getStatusContent = () => {
        const findstaus = steps.find((step) => orderTrackingData.StateVal ?? orderTrackingData?.State === step.status)
        return findstaus
    }
    const isNowWithinOpenHours = () => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' });
        const nowMinutes = now.getHours() * 60 + now.getMinutes();

        const todaySchedule = companyDetails?.openingHours.find(day => day.Day === currentDay);
        if (!todaySchedule || todaySchedule.Closed || !todaySchedule.OpenHours.length) {
            return false;
        }
        for (const range of todaySchedule.OpenHours) {
            const [startH, startM] = range.StartTime.split(':').map(Number);
            const [endH, endM] = range.EndTime.split(':').map(Number);

            const startMinutes = startH * 60 + startM;
            const endMinutes = endH * 60 + endM;
            if (startMinutes <= endMinutes) {
                if (nowMinutes >= startMinutes && nowMinutes <= endMinutes) {
                    return range;
                }
            } else {
                if (nowMinutes >= startMinutes || nowMinutes <= endMinutes) {
                    return range;
                }
            }
        }

        return null;
    }
    return (
        <div className='HospitalityDefaultOrderPageV2'>
            <MenuNavbarMini />
            <div className="order-cont-wrap">

                <div className="Order-status-container">
                    <div
                        className="Order-status-container-left">
                        <div className="order-status-wrapper">
                            <div className="order-status-wrapper-header">
                                <div className="order-status-wrapper-header-text">
                                    Order Status
                                </div>
                                <div className="order-estimation-time">
                                    {getEstimation()}
                                </div>

                            </div>
                            <div className="track-steps-container">
                                {getSteps().map((step, index) => {
                                    let stepClass = '';
                                    let currentStep = ""
                                    if (orderTrackingData.StateVal === step.status) {
                                        stepClass = '-current-step';
                                        currentStep = "INPROGRESS"
                                    }

                                    else if (index < steps.findIndex(s => s.status === orderTrackingData.StateVal)) {
                                        stepClass = '-completed-step';
                                        currentStep = "COMPLETED"

                                    }

                                    else {
                                        stepClass = '-upcoming-step';
                                        currentStep = "UPCOMING"

                                    }

                                    return (
                                        <div className={`steps-container${stepClass}`} key={index}>
                                            <div className="bubble-container">{currentStep === "COMPLETED" ? <img alt="" src={tick} className="tick-cont" /> : index + 1}</div>
                                            {index + 1 !== steps.length && <div className="left-border-step" />}
                                            <div className="status-content-container">
                                                <div className="content-head">{step.head}</div>
                                                <div className="content-track">{currentStep !== "UPCOMING" ? getTimeEstimation(step.status) : "--"}</div>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                            <div className="current-step-status-cont">
                                <div className="current-step-status-cont-header">Current Status Detail:</div>
                                <div className="current-step-status-cont-text">{getStatusContent().sub}</div>
                            </div>
                        </div>
                        {/* <div className="order-status-wrapper">
                            <div className="order-status-wrapper-header">
                                <div className="order-status-wrapper-header-text">
                                    Live Tracking
                                </div>

                            </div>
                        </div> */}
                    </div>
                    <div
                        className="Order-status-container-right">
                        <div className="order-status-wrapper">
                            <div className="order-status-wrapper-header">
                                <div className="order-status-wrapper-header-text">
                                    Order Details
                                </div>
                            </div>
                            <div className="order-tabs-cont">

                                <div className="order-tabs">
                                    <div className="order-tabs-left">
                                        Order Number
                                    </div>
                                    <div className="order-tabs-right">
                                        {orderTrackingData?.OrderID}
                                    </div>
                                </div>
                                <div className="order-tabs">
                                    <div className="order-tabs-left">
                                        Order Date
                                    </div>
                                    <div className="order-tabs-right">
                                        {moment(new Date(orderTrackingData.CreatedTime)).format('MMM DD, YYYY HH:mm A')}
                                    </div>
                                </div>
                                <div className="order-tabs">
                                    <div className="order-tabs-left">
                                        Items
                                    </div>
                                    <div className="order-tabs-right">
                                        {orderTrackingData?.Carts?.Items?.length} item(s)
                                    </div>
                                </div>
                                <div className="order-tabs">
                                    <div className="order-tabs-left">
                                        Total Amount
                                    </div>
                                    <div className="order-tabs-right">
                                        {orderTrackingData?.Payment?.
                                            PaymentDetail?.OrderTotal?.Gross?.Formatted}
                                    </div>
                                </div>
                            </div>
                            <div className="address-cont">
                                <div className="del-header">
                                    {orderTrackingData.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER" ? "Delivery" : "Billing"} Address
                                </div>
                                {orderTrackingData.FulfillmentType === "DELIVERY_BY_REWARDCONSUMER" ?
                                    <div className="address">{customerDetails?.DeliveryAddress?.AddressLine1} {customerDetails?.DeliveryAddress?.City}, {customerDetails?.DeliveryAddress?.StateProvinceRegion}, {customerDetails?.DeliveryAddress?.Country} </div>
                                    : <div className="address">{customerDetails?.BillingAddress?.AddressLine1} {customerDetails?.BillingAddress?.City}, {customerDetails?.BillingAddress?.StateProvinceRegion}, {customerDetails?.BillingAddress?.Country} </div>
                                }
                            </div>
                        </div>

                        <div className="order-status-wrapper">
                            <div className="order-status-wrapper-header">
                                <div className="order-status-wrapper-header-text">
                                    Need Help?
                                </div>
                            </div>
                            <div className="contact-cont">
                                <div className="chat-cont disable">
                                    <img alt="" src={message} className="icon-img" />Live Chat</div>
                                <div className="call-cont"
                                    onClick={() => {
                                        setShowPhone(true)
                                    }}>
                                    <img alt="" src={phone} className="icon-img" />Call Support</div>
                                <div className="support-text">Support available: {moment(isNowWithinOpenHours()?.StartTime, "HH:mm").format('hh:mm A')} - {moment(isNowWithinOpenHours()?.EndTime, "HH:mm").format('hh:mm A')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MenuFooter />
            <SupportModal visibility={showPhone}
                onClose={() => {
                    setShowPhone(false)
                }} />
        </div>

    )
}
export default HospitalityV2OrderStatus